export default "__VITE_ASSET__C0tgoD2m__"